export default __webpack_public_path__ + "static/media/push20.71d88a0e.gif";